import React from 'react';
import { USER_SCOPE_CENTRAL } from './constants';

const ShowCpanelUserComp = ({ scope, user }) => {
  if (!user) return null;
  const isCentral = scope === USER_SCOPE_CENTRAL;

  return (
    <dl className="row mb-0 cpanel-log-detail">
      {isCentral ? (
        <>
          <dt className="col-sm-4 text-muted">Username</dt>
          <dd className="col-sm-8">{user.username}</dd>
          <dt className="col-sm-4 text-muted">Nama Lengkap</dt>
          <dd className="col-sm-8">{user.namaLengkap || user.fullName || '-'}</dd>
          <dt className="col-sm-4 text-muted">Email</dt>
          <dd className="col-sm-8">{user.email || '-'}</dd>
          <dt className="col-sm-4 text-muted">Role</dt>
          <dd className="col-sm-8 text-capitalize">{user.role || '-'}</dd>
        </>
      ) : (
        <>
          <dt className="col-sm-4 text-muted">Tenant</dt>
          <dd className="col-sm-8">{user.tenantSlug || '-'}</dd>
          <dt className="col-sm-4 text-muted">Username</dt>
          <dd className="col-sm-8">{user.username}</dd>
          <dt className="col-sm-4 text-muted">Nama Lengkap</dt>
          <dd className="col-sm-8">{user.namaLengkap || '-'}</dd>
          <dt className="col-sm-4 text-muted">Email</dt>
          <dd className="col-sm-8">{user.email || '-'}</dd>
          <dt className="col-sm-4 text-muted">Role</dt>
          <dd className="col-sm-8">{user.groupName || user.role || '-'}</dd>
          <dt className="col-sm-4 text-muted">Divisi</dt>
          <dd className="col-sm-8">{user.divisionName || '-'}</dd>
          <dt className="col-sm-4 text-muted">Jabatan</dt>
          <dd className="col-sm-8">{user.jabatan || '-'}</dd>
        </>
      )}
      <dt className="col-sm-4 text-muted">Status</dt>
      <dd className="col-sm-8">{user.active || 'YES'}</dd>
    </dl>
  );
};

export default ShowCpanelUserComp;
